import Link from "components/MoodLink";

import footerLogo from 'assets/images/footer-logo.webp';

import x from 'assets/images/socialicons/x.webp';
import instagram from 'assets/images/socialicons/instagram.webp';
import linkedin from 'assets/images/socialicons/linkedin.webp';

const Footer = (props) => {
  const {className} = props;
  const currentYear = new Date().getFullYear();
  return (
    <div className={`bg-green-500 md:mt-[60px] mt-[60px] px-3 pb-5 pt-9 ${className}`}>
      <div className='container'>
        <div className='flex text-base font-bold text-tan-100 md:flex-row flex-col items-center justify-center md:gap-20 gap-10'>
          <Link to="https://hellomood.co/terms-and-conditions/">Terms Of Service</Link>
          <Link to="https://hellomood.co/privacy-policy/">Privacy Policy</Link>
          <Link to="https://hellomood.co/fda-disclaimer/">FDA Disclaimer</Link>
          <Link to="https://hellomood.co/refund-policy/">Refund Policy</Link>
        </div>
        <img src={footerLogo} alt="footer-logo" className='w-full md:mt-20 mt-7 py-4' />
        <div className='my-8 flex justify-center items-center gap-2'>
          <Link to="https://twitter.com/hellomoodcom" target="_blank">
            <img className='cursor-pointer' src={x} alt="x" />
          </Link>
          <Link to="https://www.instagram.com/hellomoodco/" target="_blank">
            <img className='cursor-pointer' src={instagram} alt="instagram" />
          </Link>
          <Link to="https://www.linkedin.com/company/hellomood/" target="_blank">
            <img className='cursor-pointer' src={linkedin} alt="linkedin" />
          </Link>
        </div>
        <div className='mt-8 text-tan-100 font-bold text-sm text-center uppercase'>All rights reserved &copy; MOOD { currentYear }</div>
      </div>
    </div>
  )
};

export default Footer;